/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {PropsWithChildren} from 'react'
import {Spinner} from "react-bootstrap";
import styled from "styled-components";


const LoaderWrapper = styled.div<any>({
  display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'
})

interface IProps {
  isLoading: boolean
  wrapperStyle?: any
  loaderSize?: number | string
}

const Loader = (props: PropsWithChildren<IProps>) => {
  return (
    <>
      {props.isLoading ?
        <LoaderWrapper style={props.wrapperStyle}>
          <Spinner animation={'border'} style={{color: 'grey', width: props.loaderSize, height: props.loaderSize}}/>
        </LoaderWrapper> :
        props.children ?? null
      }
    </>

  )
}

export default Loader